module.exports = __webpack_public_path__ + "img/download-enabled.2fdb5309.svg";